<template>
    <div>
        <template v-if="manage_payment_messages == true">
            <div class="modal fade" id="instruction" tabindex="-1" role="dialog" aria-labelledby="batchSummaryLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body batchSummary-payment-popup text-left p-4">
                            <div class="popup-head line-head">
                                <h2 class="pb-2"> Customize your message </h2>
                            </div>
                            <div class="row normal-ib-space mt-3">
                                <div class="col-md-12 mb-3">
                                    <p>Hi <span v-html="'{{name}}'"></span>! <span v-html="'{{company_name}}'"></span> has processed your salary with amount <span v-html="'{{salary}}'"></span> into your account <span v-html="'{{account_number}}'"></span> through <span v-html="'{{account_type}}'"></span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-top mb-1 mb-3">
                <h1> Edit Payment Message</h1>
            </div>
            <div class="global-main">
                <form @submit.prevent="editPaymentMessage">
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Account Type </label>
                            <select name="account_type" id="account_type" v-model="form.account_type" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('account_type') }">
                                <option value="SIMSIM" :selected="form.account_type == 'SIMSIM'">SIMSIM</option>
                                <option value="BANK" :selected="form.account_type == 'BANK'">BANK</option>
                                <option value="IBFT" :selected="form.account_type == 'IBFT'">IBFT</option>
                                <!--<option value="EMONEY" :selected="form.account_type == 'EMONEY'">EMONEY</option>-->
                                <option value="EASY_PAISA_WALLET" :selected="form.account_type == 'EASY_PAISA_WALLET'">EASYPAISA WALLET</option>
                                <option value="EASY_PAISA_CNIC" :selected="form.account_type == 'EASY_PAISA_CNIC'">EASYPAISA CNIC</option>
                            </select>
                            <has-error :form="form" field="account_type"></has-error>
                        </div>

                        <div class="form-group">
                            <label> Profile Type </label>
                            <select name="profile_type" id="profile_type" v-model="form.profile_type" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('profile_type') }">
                                <option value="EMPLOYEE" :selected="form.profile_type == 'EMPLOYEE'">EMPLOYEE</option>
                                <option value="VENDOR" :selected="form.profile_type == 'VENDOR'">VENDOR</option>
                            </select>
                            <has-error :form="form" field="profile_type"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Message </label> <a href="javascript:void(0)" data-toggle="modal" data-target="#instruction">Sample</a>
                            <textarea name="text" v-model="form.text" id="" maxlength="150" placeholder="Max length : 150" cols="100" rows="10" class="form-control" :class="{ 'is-invalid': form.errors.has('text') }">{{form.text}}</textarea>
                            <has-error :form="form" field="text"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/paymentMessages" class="btn btn-primary float-right mr-2">Back</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="manage_payment_messages === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="manage_payment_messages === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    account_type : '',
                    profile_type : '',
                    text : '',
                    id : '',
                }),
                manage_payment_messages:null
            };
        },
        methods: {
            editPaymentMessage() {
                this.$Progress.start();
                this.form.post('/api/updatePaymentMessage')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success','Message is updated successfully');
                            this.$router.push('/paymentMessages');
                        }else{
                            this.$Progress.fail();
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            },
            getData(){
                axios.get('/api/editPaymentMessage/'+this.$route.params.id)
                    .then(res => {
                        if(res.status == 200){
                            this.form.id = res.data.id;
                            this.form.text = res.data.text;
                            this.form.profile_type = res.data.profile_type;
                            this.form.account_type = res.data.account_type;
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                        }
                    }).then(res=>{
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                    })
                    .catch(err => {
                        console.log(err);
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.$Progress.fail();
                    });
            }

        },
        mounted() {
            this.$Progress.start();
            this.can('manage_payment_messages').then(result => {
                this.manage_payment_messages = result.manage_payment_messages;
            }).then(result => {
                if(this.manage_payment_messages == true){
                    this.getData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });

        },
        created() {

        }
    }
</script>
